@let controlValue = control();

<mat-form-field class="list-filter-form-field">
  <mat-label>{{ label() }}</mat-label>
  <mat-select [formControl]="controlValue">
    <mat-option [value]="true">{{ `${coreI18nCommonScope}YES` | transloco }}</mat-option>
    <mat-option [value]="false">{{ `${coreI18nCommonScope}NO` | transloco }}</mat-option>
  </mat-select>
  <cappus-filter-clear-button matSuffix [control]="controlValue" />
</mat-form-field>
